<template>
  <el-col :span="24"  class="hidden-md-and-down">
    <el-button v-show="isManager('project') && isTowerCo()"
     icon="fa fa-trash-alt" @click="deleteEntry()"
      size="small"
       type="danger" circle
       :disabled="isViewOnly()"></el-button>
  </el-col>
</template>

  <script>

  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],

    props: {
      rowData: {
        type: Object,
        required: true
      },

      tableRef: {
        type: String,
        default: '-action-table'
      }
    },


    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/actions', this.rowData.actionType + ' ' + this.rowData.summary + ' INCLUDING all files', this.onDelete)
      },

      onDelete (response) {
        let tref = this.tableRef

        if (tref === '-action-table') {
          tref = this.rowData.actionType.toLowerCase() + this.tableRef
        }

        this.$events.emit(tref + '-refresh-table')
      }
    }

  }
  </script>
